import { useMutation, useQueryClient } from '@tanstack/react-query';
import type { BrandDetachRequest } from '@brand24-original/llm-types';
import { detachBrand } from '../../../../services/monitor/keywords/KeywordsService';
import { invalidateBrandGrouping } from './useSetBrandGroup';

/** Odłączenie dołączonej marki w całości — te same unieważnienia co każda zmiana grupowania. */
export const useDetachBrand = (projectId: number, options?: { onError?: () => void }) => {
  const queryClient = useQueryClient();

  return useMutation({
    mutationFn: (request: BrandDetachRequest) => detachBrand(request),
    onSuccess: () => invalidateBrandGrouping(queryClient),
    onError: () => options?.onError?.(),
  });
};
